const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.001 2.99902V9.3916L19.0342 7.75684L19.9854 7.44824L20.2949 8.39941L20.9121 10.3008L21.2217 11.252L20.2705 11.5615L15.2891 13.1787L18.2959 17.3164L18.8828 18.125L18.0742 18.7129L16.4561 19.8887L15.6475 20.4766L15.0596 19.668L11.9395 15.373L8.86133 19.6104L8.27441 20.4189L7.46484 19.8311L5.84668 18.6553L5.03809 18.0684L5.62598 17.2588L8.61426 13.1445L3.73145 11.5576L2.78027 11.249L3.08887 10.2979L3.70703 8.39551L4.01562 7.44434L4.9668 7.75391L10.001 9.38867V2.99902H14.001Z",
    style: {
      strokeOpacity: 1
    },
    strokeWidth: 2
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.a95a86471a713b54df214c888d3f6255.svg";
export { ForwardRef as ReactComponent };